/**
 * 计价明细的科目码(M-02、M-13)。**单点定义在这里,三端引用。**
 *
 * 与契约 components.schemas.PriceItem.code 的 enum 逐字一致 ——
 * guards/check-pricing-no-hardcode.mjs 会双向核对这两处,少一个多一个都报红。
 *
 * 六个码里,S-02 的试算只会用到四个:
 *   weight_tier         重量档
 *   distance_tier       距离档(锚地内/外各一套)
 *   volume_tier         超长规格加价(只在 oversized 时出现)
 *   agency_fee          代办服务费(M-13,现在初值 0)
 *
 * 另外两个 base_freight / anchorage_surcharge 现在**一行代码都没用到**,
 * 原因写在守卫的 UNUSED_PRICE_ITEM_CODES 登记表里:
 * 锚地内/外的差价是靠两套完整的档位表实现的(M-02 原文「分两套基价表」),
 * 不是靠在同一套表上加一笔附加费。等甲方给了真表,如果它长的是「一个起步价 + 附加费」
 * 的样子,那时启用这两个码 —— 但那必须是一次显式的改动,不许某天悄悄多出一个码。
 */
export const PRICE_ITEM_CODE = [
  'base_freight',
  'weight_tier',
  'volume_tier',
  'distance_tier',
  'anchorage_surcharge',
  'agency_fee',
] as const

export type PriceItemCode = (typeof PRICE_ITEM_CODE)[number]

export function isPriceItemCode(x: unknown): x is PriceItemCode {
  return typeof x === 'string' && (PRICE_ITEM_CODE as readonly string[]).includes(x)
}

/** 锚地内 / 锚地外 —— 两套基价(M-02) */
export const ANCHORAGE_SCOPE = ['inside', 'outside'] as const

export type AnchorageScope = (typeof ANCHORAGE_SCOPE)[number]
